import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorsService {

  constructor( private notification: NotificationService,
               private router: Router) { }

    getErrorMessage(error){
      console.log('Error Recibidoooo +2', error);
      console.log('Código de error recibido ', error.status);
      let descError
      if (error != undefined){
        switch (error.status){
          case 500:
          descError = 'Error en conexión al servidor, por favor vuelve a intentarlo.'
          break;
          case 404:
          descError = 'Error, no se encontró el servicio a consumir'
          break;
          default:
          var n;
          var l;
          if (error.error.error.message != undefined){
            n = error.error.error.message.indexOf(":")
            descError = error.error.error.message.substring( n + 1, 99)
            l = descError.indexOf(":");
            descError = descError.substring(l + 1, 99)
          } else {
            descError = error.error.message
          }
          break;
        }
        return descError;
      } else {
        return 'Error en conexión al servidor, por favor vuelve a intentarlo.'
      }
    }
    

  getError(status, result){
    console.log('HTTP_ERROR - Respuesta Recibida con Error ', result.toString(), status);
    return new Promise ((resolve =>{
      // Según status recibido
      switch(status){
        case 0: 
        this.notification.showNotification('Se detectó un error en la conexión al servidor, por favor comuniquese con el departamento de IT.');
        break;
        case -1:
          this.notification.showNotification('No fue posible recuperar información, por favor intenta de nuevo.');
        break;
        case 401:
        this.notification.showNotification('Sesión ha expirado');
        // Logout automático
        setTimeout(()=>{
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          localStorage.removeItem('usernameId');
          localStorage.removeItem('menu');
          localStorage.removeItem('homePage');
          localStorage.removeItem('role');
          this.router.navigate(['login']);
        },1500)
        break;
        case 504: 
        this.notification.showNotification('Error en la conexión al servidor');
        break;
        case 404:
        this.notification.showNotification('Error, no se encontró el servicio a consumir');
        break;
        default:
        this.notification.showNotification(this.getErrorMessage(result));
        break;
      }
    }))
  }

}

